(function (window) {
  'use strict';

  /*
    This does two things when a user selects where they purchased:
    Set the order details label based on their selection.
    Remove the disabled attribute from order details input.
    If no selection, revert to original state.
  */
  const purchaseWhere = document.querySelector('.js-select--purchase-where');
  const purchaseLocation = document.querySelector('.js-form-item--purchase-location');
  const placeholderInfo = ["Order Number", "Store Name", "Website"];

  if (purchaseWhere && purchaseLocation) {
    const locationLabel = purchaseLocation.getElementsByTagName('label')[0];
    const locationInput = purchaseLocation.getElementsByTagName('input')[0];

    purchaseWhere.addEventListener('change', (e) => {
      const selection = e.target.options[e.target.selectedIndex].text;
      const selectionIndex = e.target.selectedIndex - 1;

      if (e.target.value) {
        locationLabel.innerHTML = selection;
        locationInput.placeholder = placeholderInfo[selectionIndex];
        locationInput.removeAttribute('disabled');
      }
      else {
        locationLabel.innerHTML = "";
        locationInput.value = "";
        locationInput.placeholder = "Order Details";
        locationInput.setAttribute('disabled', true);
      }
    });
  }

})(this);
